import { render, staticRenderFns } from "./MainColumns.vue?vue&type=template&id=a63c71e4&scoped=true&"
import script from "./MainColumns.vue?vue&type=script&lang=ts&"
export * from "./MainColumns.vue?vue&type=script&lang=ts&"
import style0 from "./MainColumns.vue?vue&type=style&index=0&id=a63c71e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63c71e4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a63c71e4')) {
      api.createRecord('a63c71e4', component.options)
    } else {
      api.reload('a63c71e4', component.options)
    }
    module.hot.accept("./MainColumns.vue?vue&type=template&id=a63c71e4&scoped=true&", function () {
      api.rerender('a63c71e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/MainColumns.vue"
export default component.exports